import {
    Route,
    Routes,
} from 'react-router-dom';
import {RequirePermission} from '../../utils/RequirePermission.tsx';

import {IndexPage} from './pages/IndexPage';
import {rbacActions} from '../../config/rbac/actions.ts';

// FNP-891: single index route. Each control carries its own explanation inline,
// so there is nothing behind a detail page worth navigating to.
export const PlatformControlsLayout = () => {

    return (
        <Routes>
            <Route
                path='/'
                element={
                    <RequirePermission action={rbacActions.ListPlatformControls}>
                        <IndexPage/>
                    </RequirePermission>
                }
            />
        </Routes>
    );
};
